import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from 'src/app/service/translate.service';
import { MatTableDataSource } from '@angular/material';
import {  Reservation, ReservationItem } from 'src/app/model/reservation.model';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {


  @Input() reservation: Reservation;

  orderItemsSource = new MatTableDataSource<ReservationItem>();
  orderItemsDisplayedColumns = ['productDescription', 'quantity', 'price', 'tax', 'amount'];

  constructor(
    public translationService: TranslationService) { }

  ngOnInit() {
    this.orderItemsSource.data = this.reservation.reservationItems;
  }

}
